import React, { useRef } from "react";
import Popover from "antd/lib/popover";
import InputNumber from "antd/lib/input-number";
import "./index.less";
import { IPopInputProps } from "./interface";

const ZPopInput: React.FC<IPopInputProps> = React.memo(props => {
	const { block = true, disabled } = props;
	const inputRef = useRef<any>(null);
	const inputLabelRef = useRef<HTMLDivElement | null>(null);
	const [value, setValue] = React.useState<number | string>(
		props.value ?? ""
	);
	const handleVisibleChange = (isVisible: boolean) => {
		if (!inputRef.current) {
			return;
		}
		if (isVisible) {
			inputRef.current.focus();
		}
	};
	const handleClick = () => {
		inputRef.current && inputRef.current.focus();
	};

	const handleChange = (number?: number | string | null) => {
		if (!props.onChange) {
			return;
		}

		if (typeof number === "number") {
			if (props.min !== undefined && number < props.min) {
				setValue(props.min);
				return;
			}
			if (props.max !== undefined && number > props.max) {
				setValue(props.max);
				return;
			}

			setValue(number);
		}

		if (typeof number === "string" && number === "") {
			setValue(props.min ?? 0);
		}
	};

	const handleInputKeys = (event: React.KeyboardEvent<HTMLInputElement>) => {
		const keyCode = event.keyCode;
		if (!props.decimal && keyCode === 190) {
			// key code for '.'
			event.preventDefault();
			return;
		}
	};

	return (
		<Popover
			onVisibleChange={handleVisibleChange}
			getPopupContainer={triggerNode =>
				triggerNode.parentNode as HTMLElement
			}
			content={
				<InputNumber
					type="number"
					ref={inputRef}
					value={value}
					min={props.min}
					max={props.max}
					onChange={handleChange}
					onKeyDown={handleInputKeys}
				/>
			}
		>
			<div
				ref={inputLabelRef}
				className={`pop-input ${block ? "full-width" : ""} ${
					props.inputAlign === "right" ? "right-aligned" : ""
				} ${props.size || ""} ${props.className || ""} ${
					disabled ? "disable-pop-input" : ""
				}`}
				onClick={handleClick}
			>
				{props.formatter && props.formatter(value)
					? props.formatter(value)
					: value}
			</div>
		</Popover>
	);
});

export default ZPopInput;
